module.exports = __webpack_public_path__ + "img/id.c3602b3c.png";